import { Link } from 'react-router-dom';
import { cpLines } from '@/mocks/cps';
import SectionTitle from '@/components/base/SectionTitle';

const toneMap = {
  primary: 'bg-primary-500',
  accent: 'bg-accent-500',
  secondary: 'bg-secondary-500',
};

const badgeMap = {
  primary: 'bg-primary-100 text-primary-700',
  accent: 'bg-accent-100 text-accent-800',
  secondary: 'bg-secondary-100 text-secondary-900',
};

export default function CpSection() {
  return (
    <section className="mx-auto w-full max-w-7xl px-4 py-14 md:px-6 md:py-20">
      <SectionTitle
        mark="CP"
        title="热门CP线专题"
        subtitle="师兄师姐互动名场面、CP线发展脉络全梳理，从官配主线到江湖知己，总有一条能戳中你。"
      />
      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {cpLines.map((cp) => (
          <Link
            key={cp.id}
            to="/cp"
            className="group flex flex-col rounded-xl border border-background-200/70 bg-background-50 p-5 transition-all duration-300 hover:-translate-y-1 hover:border-primary-200"
          >
            <div className="flex items-start justify-between gap-2">
              <h3 className="font-heading text-lg font-bold text-foreground-950 transition-colors group-hover:text-primary-700">
                {cp.name}
              </h3>
              <span className={`whitespace-nowrap rounded-md px-2 py-1 text-xs ${badgeMap[cp.tone]}`}>
                {cp.intensity}% 热度
              </span>
            </div>
            <p className="mt-1 text-sm font-medium text-primary-600">{cp.pair}</p>
            <div className="mt-3 h-1.5 w-full overflow-hidden rounded-full bg-background-200">
              <div className={`h-full rounded-full ${toneMap[cp.tone]}`} style={{ width: `${cp.intensity}%` }} />
            </div>
            <p className="mt-4 line-clamp-3 flex-1 text-sm leading-6 text-foreground-600">{cp.summary}</p>
            <span className="mt-4 inline-flex items-center gap-1 text-sm font-medium text-primary-600">
              查看专题 <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" />
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}